import {
  getSalesforceConnection,
  getSalesforceConnectionByAccessToken,
} from './getSalesforceConnection';
export const isUnauthorized = (err) => err.errorCode === 'ERROR_HTTP_400';
export const isInvalid = (err) => err.errorCode === 'INVALID_SESSION_ID';
const isExpired = (err) =>
  err.errorCode === 'INVALID_OPERATION_WITH_EXPIRED_PASSWORD';

export const queryWithSOQL = async (
  soql,
  credentials,
  shouldUseRefreshedConnection
) => {
  try {
    const conn = getSalesforceConnection(
      credentials,
      shouldUseRefreshedConnection
    );

    const data = await conn.query(soql, { autoFetch: true });

    return { records: data.records, nextRecordsUrl: data.nextRecordsUrl };
  } catch (error) {
    if (isUnauthorized(error)) {
      await queryWithSOQL(soql, credentials, true);
      return;
    }

    if (isExpired(error)) {
      return new Error('EXPIRED_PASSWORD');
    }
  }
};

export const queryForNextRecords = async (
  nextRecordsUrl,
  credentials,
  shouldUseRefreshedConnection
) => {
  try {
    const conn = await getSalesforceConnection(
      credentials,
      shouldUseRefreshedConnection
    );
    await conn.queryMore(nextRecordsUrl, { autoFetch: true });
  } catch (error) {
    if (isUnauthorized(error)) {
      queryForNextRecords(nextRecordsUrl, credentials, true);
    }

    if (isExpired(error)) {
      return new Error('EXPIRED_PASSWORD');
    }
  }
};

export const update = async (
  credentials,
  object,
  data,
  shouldUseRefreshedConnection
) => {
  try {
    const conn = await getSalesforceConnection(
      credentials,
      shouldUseRefreshedConnection
    );
    await conn.sobject(object).update(data);
    return { success: true };
  } catch (error) {
    console.log(error);
    if (isUnauthorized(error)) {
      update(credentials, object, data, true);
    }
    if (isExpired(error)) {
      return new Error('EXPIRED_PASSWORD');
    }
  }
};

export const create = async (
  credentials,
  object,
  data,
  shouldUseRefreshedConnection
) => {
  try {
    const conn = await getSalesforceConnection(
      credentials,
      shouldUseRefreshedConnection
    );

    const response = await conn.sobject(object).create(data);
    return { success: true, res: response };
  } catch (error) {
    if (isUnauthorized(error)) {
      update(credentials, object, data, true);
    }
    if (isExpired(error)) {
      return new Error('EXPIRED_PASSWORD');
    }
    throw error;
  }
};

export const authenticateWithAccessToken = (credentials) =>
  getSalesforceConnectionByAccessToken({
    instanceUrl: credentials.instanceUrl,
    accessToken: credentials.accessToken,
  });
